import { UseFormReturn } from "react-hook-form";

import TextEditor from "../../Global/Editors/TextEditor";
import { Table } from "react-bootstrap";
import { useGlobalData } from "../../GlobalDataProvider";
import { useRound } from "../../../modules/roundHandler";
import { numFrmtStd } from "../../../modules/common";
import { ModuleTypeId } from "../../../types/DBTables";

interface IProps {
  info: any;
}

const DebugInfo = ({ info }: IProps) => {
  const global = useGlobalData();
  const roundHandler = useRound();

  const bimHandler = roundHandler.getBimHandler();

  if (!(global?.isDebug || global?.isDebugBIM)) return <></>;

  let showDbg = global.isDebug;
  let showBim = global.isDebugBIM;

  const sections: any[] = [];
  const sectionsBIM: any[] = [];
  if (info && typeof info === "object") {
    for (let sectionName in info) {
      const section = { name: sectionName, props: [] as any[] };
      for (let propName in info[sectionName]) {
        section.props.push({ name: propName, value: info[sectionName][propName]?.toString() });
      }
      sections.push(section);
    }
  } else showDbg = false;

  if (showBim) {
    const sectionGrund = {
      name: "Grundvärden BIM",
      props: [
        { name: "G13_ÅrligBruttoAnvändningCentralVärme", value: numFrmtStd.format(bimHandler.G13_ÅrligBruttoAnvändningCentralVärme()) },
        { name: "G15_BIM_ÅrligBruttoTransmission", value: numFrmtStd.format(bimHandler.BIM_ÅrligBruttoTransmission()) },
        { name: "G17_BruttoEnergiVentilation", value: numFrmtStd.format(bimHandler.G17_BruttoEnergiVentilation()) },
        { name: "G19_BruttoEnergiVarmvatten", value: numFrmtStd.format(bimHandler.G19_BruttoEnergiTappvatten) },
      ],
    };
    sectionsBIM.push(sectionGrund);

    // const G15_dbgSection = {
    //   name: "G15 underliggande (=G13_BIM_ÅrligBruttoCentralVärme-G19_BIM_Brutto_TappVarmVatten-G17_BIM_BruttoCentralVärme_Ventilation)",
    //   props: [
    //     { name: "G13 BIM_ÅrligBruttoCentralVärme", value: numFrmtStd.format(bimHandler.G13_ÅrligBruttoAnvändningCentralVärme()) },
    //     { name: "BIM_Brutto_TappVarmVatten", value: numFrmtStd.format(bimHandler.BIM_ÅrligBruttoTransmission()) },
    //     { name: "BIM_BruttoCentralVärme_Ventilation", value: numFrmtStd.format(bimHandler.G17_BruttoEnergiVentilation()) },
    //   ],
    // };
    // sectionsBIM.push(G15_dbgSection);

    const round = roundHandler.getRoundData();
    const G17_props: any[] = [];
    const G17_dbgSection = {
      name: "G17 underliggande",
      props: G17_props,
    };

    if (round && round.data && round.data.modules) {
      round.data.modules.forEach((m) => {
        if (m.moduleTypeId === ModuleTypeId.VentilationFTX || m.moduleTypeId === ModuleTypeId.VentilationFT) {
          const bflJ3 = m.bfs.BFL_J3_FTX_FT;
          //G17_dbg["BFL_J3_FTX(" + m.name + ")"] = bflJ3 && bflJ3.data?.export?.energiAnvCentralUppvärmning;
          G17_props.push({ name: "BFL_J3_FTX(" + m.name + ")", value: bflJ3 && bflJ3.data?.export?.energiAnvCentralUppvärmning });
        }
        if (m.moduleTypeId === ModuleTypeId.VentilationFX || m.moduleTypeId === ModuleTypeId.VentilationF) {
          const bflJ3 = m.bfs.BFL_J3_FX_F;
          //G17_dbg["BFL_J3_FX(" + m.name + ")"] = bflJ3 && bflJ3.data?.export?.årligEnergiFörlust;
          G17_props.push({ name: "BFL_J3_FX(" + m.name + ")", value: bflJ3 && bflJ3.data?.export?.årligEnergiFörlust });
        }
        if (m.moduleTypeId === ModuleTypeId.VentilationS) {
          const bflJ3 = m.bfs.BFL_J3_S;
          //G17_dbg["BFL_J3_S(" + m.name + ")"] = bflJ3 && bflJ3.data?.export?.årligEnergiAnvändning;
          G17_props.push({ name: "BFL_J3_S(" + m.name + ")", value: bflJ3 && bflJ3.data?.export?.årligEnergiAnvändning });
        }
      });
    }

    sectionsBIM.push(G17_dbgSection);
  }
  return (
    <>
      {showDbg && (
        <div>
          <div>DEBUG</div>
          <Table bordered striped>
            {sections.map((section) => (
              <>
                <thead key={section}>
                  <tr>
                    <th colSpan={2}>{section.name}</th>
                  </tr>
                  {/* <tr>
                  <th>Namn</th>
                  <th>Värde</th>
                </tr> */}
                </thead>
                <tbody>
                  {section.props.map((prop: any) => (
                    <tr key={prop.name}>
                      <td>{prop.name}</td>
                      <td>{prop.value}</td>
                    </tr>
                  ))}
                </tbody>
              </>
            ))}
          </Table>
        </div>
      )}
      {showBim && (
        <div>
          <div>DEBUG BIM</div>
          <Table bordered striped>
            {sectionsBIM.map((section) => (
              <>
                <thead key={section}>
                  <tr>
                    <th colSpan={2}>{section.name}</th>
                  </tr>
                  {/* <tr>
                  <th>Namn</th>
                  <th>Värde</th>
                </tr> */}
                </thead>
                <tbody>
                  {section.props.map((prop: any) => (
                    <tr key={prop.name}>
                      <td>{prop.name}</td>
                      <td>{prop.value}</td>
                    </tr>
                  ))}
                </tbody>
              </>
            ))}
          </Table>
        </div>
      )}
    </>
  );
};

export default DebugInfo;
